<template>
  <div class="hvh-flex align-center">
    <CheckBox :value="value.show" @input="emitValue('show', $event)" />
    <v-text-field class="ml-3 mt-0 pt-0" :value="value.text" :placeholder="value.originalText" :title="value.originalText" hideDetails :rules="requiredRules" @input="emitValue('text', $event)" />
  </div>
</template>

<script>
import CheckBox from '../common/form/checkbox/CheckBox.vue';
export default {
  components: { CheckBox, },
  props: ['value',],
  data() {
    return {
      showArrows: false,
      requiredRules: [v => !!v || v === false || 'Field is required'],
    };
  },
  methods: {
    emitValue(prop, event) {
      this.$emit('input', {
        ...this.value,
        [prop]: event,
      });
    },
  },
}
</script>